module.exports = __webpack_public_path__ + "static/ACI-10cb525fc197ea62eae0db7788d95104.png";